import useSWR from "swr";

type StoreModalResponseEntry = {
  productCode: string;
  displayModal: boolean;
};
type StoreStockModalResult = { storeModalResponse: StoreModalResponseEntry[] };

const getStoreStockInfoAvailability = async (
  displayCode: string,
  storeStockModalApiUrl: string,
  stockApiBaseUrl: string,
  stockApiKey: string,
): Promise<Record<string, boolean>> => {
  const requestUrl = new URL(storeStockModalApiUrl, stockApiBaseUrl);
  requestUrl.searchParams.set("productCodes", displayCode);
  requestUrl.searchParams.set("key", stockApiKey);

  return await fetch(requestUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error(response.statusText);
    })
    .then((result: StoreStockModalResult) => {
      return result.storeModalResponse.reduce(
        (list, { productCode, displayModal }) => ({
          ...list,
          [productCode]: displayModal,
        }),
        {},
      );
    });
};

export const useStoreStockInfoAvailability = (
  displayCode: string,
  storeStockModalApiUrl: string,
  stockApiBaseUrl: string,
  stockApiKey: string,
) => {
  return useSWR(
    displayCode,
    () =>
      getStoreStockInfoAvailability(
        displayCode,
        storeStockModalApiUrl,
        stockApiBaseUrl,
        stockApiKey,
      ),
    {
      revalidateIfStale: true,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );
};
